export default __webpack_public_path__ + "static/media/logo-facebook.67003e38.svg";